module.exports = __webpack_public_path__ + "static/sunset-ridge-phase-3-plat-map-961736cbf7abf066e51b07a583c32640.jpg";